import React, { useState, useEffect } from "react";
import { RISK_STEPS } from "components/constants/profileFields";
import { getSingleteam, messageClean } from "redux-store/care-team/care-team.slice";
import { singleteam } from "redux-store/care-team/care-team.selector";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux-store/store";
import LogoPng from "../../assets/images/oncotect-logo.png";

const ParentResult = React.forwardRef((props: any, ref: any) => {
  const [riskLevelColor, setRiskLevelColor] = useState("");
  const [riskLevel, setRiskLevel] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  // const team = useSelector(singleteam);
  const [team, setTeam] = useState<any>({});
  const [imageData, setImageData] = useState<any>("");

  useEffect(() => {
    if (props.result.riskValue < 0.04) {
      setRiskLevelColor("tw-bg-[#d7f6ff]");
      setRiskLevel("low");
    } else if (props.result.riskValue >= 0.04 && props.result.riskValue < 0.1) {
      setRiskLevelColor("tw-bg-[#FBD881]");
      setRiskLevel("moderate");
    } else if (props.result.riskValue >= 0.1) {
      setRiskLevelColor("tw-bg-[#FF7B6D]");
      setRiskLevel("high");
    }
  }, [props.result.riskValue]);

  // useEffect(() => {
  //   dispatch(messageClean());
  //   dispatch(getSingleteam(props.result.kitId.careTeams[0]));
  // }, []);

  useEffect(() => {
    dispatch(messageClean());
    dispatch(getSingleteam(props.result.kitId.careTeams[0])).then((res: any) => {
      if (res.payload.careTeam) {
        setTeam(res.payload.careTeam);
      }
    });
  }, []);

  useEffect(() => {
    // Load the PNG image using fetch
    fetch(LogoPng)
      .then((response) => response.blob())
      .then((blob) => {
        // Convert the blob to a Base64 encoded string
        const reader = new FileReader();
        reader.onload = () => {
          const base64Data = reader.result;
          setImageData(base64Data);
        };
        reader.readAsDataURL(blob);
      });
  }, []);

  function calculateAgeInMonths(birthdate: any) {
    const today = new Date();
    const birthdateObj = new Date(birthdate);

    // Calculate the difference in years and months
    const yearsDiff = today.getFullYear() - birthdateObj.getFullYear();
    const monthsDiff = today.getMonth() - birthdateObj.getMonth();

    // Convert the years and months difference to months
    const totalMonths = yearsDiff * 12 + monthsDiff;

    return totalMonths;
  }

  return (
    <React.Fragment>
      <div ref={ref} id="parentResult" className=" tw-flex tw-w-[1200px] tw-items-center tw-flex-col tw-bg-[#F7F6F4]">
        <img src={`${imageData}`} className="tw-w-36 tw-pt-5 tw-object-contain" alt="logo" />
        <div className="tw-uppercase tw-text-3xl tw-pt-4">Multi-Cancer Screening Test Results for Pet Parent</div>

        <div className="tw-text-8xl tw-py-5">{props?.result?.petId?.petName || "No Name"}</div>

        <div className="tw-bg-white tw-w-[90%] tw-p-3">
          {/* first half */}
          <div className="tw-border-b-2  tw-border-[#E3E3E3] tw-flex tw-items-center tw-justify-between">
            <div className="tw-text-3xl tw-font-bold tw-inline-block">Cancer Risk Level</div>
            <div
              className={`tw-rounded ${riskLevelColor} tw-capitalize tw-text-[40px] tw-mb-5 tw-mt-5 tw-w-[50%] tw-h-16 tw-flex tw-justify-center tw-items-center`}
            >
              {riskLevel}
            </div>
          </div>

          {/* 3rd half */}
          <div>
            <div className="tw-pt-3">
              <div className="tw-text-3xl tw-font-bold">Next Steps</div>
              <ul className="tw-list-disc tw-pl-7 tw-py-2 tw-text-xl tw-w-[95%]">
                {riskLevel === "low" && RISK_STEPS[0].low}
                {riskLevel === "moderate" && RISK_STEPS[0].moderate}
                {riskLevel === "high" && RISK_STEPS[0].high}
              </ul>
            </div>
          </div>
        </div>

        {/* -------------- */}
        <div className="tw-bg-white tw-w-[90%] tw-mt-4 tw-px-7 tw-py-5">
          <div className="tw-flex tw-flex-col tw-pr-9">
            <div className="tw-text-[28px] tw-font-bold tw-pb-3 tw-border-b-2 tw-border-b-[#E3E3E3]">
              Your Pet Information
            </div>

            <div className="tw-flex tw-flex-col">
              <div className="tw-pt-2 tw-flex">
                <label className="tw-text-xl tw-uppercase tw-font-medium tw-w-60">PATIENT NAME</label>
                <div className="tw-inline-block tw-w-[100%] tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {props?.result?.petId?.petName || "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2 tw-flex">
                <label className="tw-text-xl tw-uppercase tw-font-medium tw-w-60">GENDER</label>
                <div className="tw-inline-block tw-w-[100%] tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {props.result.petId.petGender || "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2 tw-flex">
                <label className="tw-text-xl tw-uppercase tw-font-medium tw-w-60">PET'S PARENT</label>
                <div className="tw-inline-block tw-w-[100%] tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {props.result.userId.fullName || "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2 tw-flex">
                <label className="tw-text-xl tw-uppercase tw-font-medium tw-w-60">AGE</label>
                <div className="tw-inline-block tw-w-[100%] tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {props.result.petId.birthDate !== null
                      ? calculateAgeInMonths(props.result.petId.birthDate) === 0
                        ? "Less than 1 Month"
                        : calculateAgeInMonths(props.result.petId.birthDate) + " month's"
                      : "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2 tw-flex">
                <label className="tw-text-xl tw-uppercase tw-font-medium tw-w-60">SPECIES</label>
                <div className="tw-inline-block tw-w-[100%] tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">{props.result.petId.petType || "None"}</div>
                </div>
              </div>
              <div className="tw-pt-2 tw-flex">
                <label className="tw-text-xl tw-uppercase tw-font-medium tw-w-60">HOSPITAL</label>
                <div className="tw-inline-block tw-w-[100%] tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">{(team && team.hospitalName) || "None"}</div>
                </div>
              </div>
              <div className="tw-pt-2 tw-flex">
                <label className="tw-text-xl tw-uppercase tw-font-medium tw-w-60">BREED</label>
                <div className="tw-inline-block tw-w-[100%] tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">{props.result.petId.petBreed || "None"}</div>
                </div>
              </div>
            </div>
          </div>

          {/* second half */}
          <div className="tw-flex tw-flex-col tw-pt-4">
            <div className="tw-text-[28px] tw-font-bold tw-pb-4 tw-border-b-2 tw-border-b-[#E3E3E3]">
              Kit Order Info
            </div>
            <div className="tw-flex tw-justify-between tw-items-center">
              <div className="tw-pt-2 ">
                <label className="tw-text-[16px] tw-uppercase tw-font-medium tw-w-[150px]">ORDER NUMBER</label>
                <div className="tw-inline-block tw-w-40 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center tw-truncate tw-overflow-auto tw-text-[11px]">
                    {props.result.kitId._id || "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2 ">
                <label className="tw-text-[16px] tw-uppercase tw-font-medium tw-w-[150px]">SAMPLE RECEIVED</label>
                <div className="tw-inline-block tw-w-40 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {new Date(props.result.createdAt).toLocaleDateString().toString() || "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2 ">
                <label className="tw-text-[16px] tw-uppercase tw-font-medium tw-w-[150px]">RESULT REPORTED</label>
                <div className="tw-inline-block tw-w-40 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {new Date(props.result.updatedAt).toLocaleDateString().toString() || "None"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="tw-mt-2">
          <div className="tw-align-middle">
            <img src={`${imageData}`} className="tw-inline-block tw-w-20 tw-pb-[30px] tw-object-contain" alt="logo" />
            <div className="tw-text-6xl tw-inline-block tw-pr-5 tw-border-r-4 tw-border-r-[#afafaf]">oncotect</div>
            <div className="tw-text-[18px] tw-font-bold tw-w-80 tw-uppercase tw-inline-block tw-pl-5">
              accessible early cancer screening tests for dogs
            </div>
          </div>
        </div>
        <div className="tw-mt-[2px] tw-w-[95%]">
          <div className="tw-font-bold">Important Disclosure on Oncotect Test Results</div>
          <p className="tw-mt-1 tw-mb-1">
            Please be advised that the early screening test results provided by Oncotect are not intended to serve as a
            definitive diagnosis. Oncotect is a risk assessment tool based on clinical studies of four cancer types
            (lymphoma, hemangiosarcoma, mast cell tumor, and melanoma) and is designed to evaluate the risk of cancer at
            the time the test was performed. A "low risk" test result does not guarantee the absence of cancer, while a
            "moderate" or "high cancer risk" result does not conclusively confirm the presence of cancer. It is crucial
            for pet owners not to rely solely on the results of Oncotect for diagnostic purposes, but instead to consult
            with their veterinarian for proper interpretation and guidance. Further testing and/or examination may be
            recommended by the veterinarian to obtain a more accurate assessment of your pet's health. By using
            Oncotect, you acknowledge and understand the limitations of the test and agree that the company providing
            the Oncotect test shall not be held liable for any misinterpretation or reliance on the test results without
            the advice of a qualified veterinarian.
          </p>
        </div>
      </div>
    </React.Fragment>
  );
});

export default ParentResult;
